import React, { useState, useEffect } from 'react'
import { Button, Checkbox, TextField } from '@mui/material'
import { BACKEND_URI } from '../config'

function Discounts({}) {
  const [discountRules, setDiscountRules] = useState([])
  const [newDiscount, setNewDiscount] = useState({
    min: 0,
    max: 0,
    percentage: 0,
  })
  const [noMin, setNoMin] = useState(false)
  const [noMax, setNoMax] = useState(false)

  useEffect(() => {
    const fetchDiscounts = async () => {
      try {
        const token = localStorage.getItem('token')
        const response = await fetch(`${BACKEND_URI}/api/discounts`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })

        const data = await response.json()
        setDiscountRules(data)
      } catch (error) {
        console.error('Error fetching discounts:', error)
      }
    }

    fetchDiscounts()
  }, [])

  const handleAddDiscount = async e => {
    e.preventDefault()
    try {
      const token = localStorage.getItem('token')
      const newRule = {
        priceRange: { min: newDiscount.min, max: newDiscount.max },
        discountPercentage: newDiscount.percentage,
      }

      const response = await fetch(`${BACKEND_URI}/api/discounts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(newRule),
      })

      const data = await response.json()

      if (response.ok) {
        setDiscountRules(prev => [...prev, data.rule])
        setNewDiscount({ min: 0, max: 0, percentage: 0 })
      } else {
        console.error('Failed to add discount rule.')
      }
    } catch (error) {
      console.error('Error adding discount:', error)
    }
  }

  const handleDeleteDiscount = async ruleId => {
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(
        `${BACKEND_URI}/api/discounts/${ruleId}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      )

      if (response.ok) {
        // Remove the deleted rule from the local state
        setDiscountRules(prev => prev.filter(rule => rule._id !== ruleId))
      } else {
        console.log(response)
        console.error('Failed to delete discount rule.')
      }
    } catch (error) {
      console.error('Error deleting discount:', error)
    }
  }

  return (
    <div style={styles.adminSection}>
      <h2>Discount Rules</h2>

      {/* Display Existing Discounts */}
      <ul style={styles.discountList}>
        {discountRules.map((rule, index) => (
          <li key={index} style={styles.discountItem}>
            Price Range:{' '}
            {rule.priceRange.min !== 0 ? `$${rule.priceRange.min}` : 'No Min'} -{' '}
            {rule.priceRange.max !== 9999999
              ? `$${rule.priceRange.max}`
              : 'No Max'}
            , Discount: {rule.discountPercentage}%
            <Button
              variant='contained'
              color='error'
              onClick={() => handleDeleteDiscount(rule._id)}
              style={styles.deleteButton}
            >
              Delete
            </Button>
          </li>
        ))}
      </ul>

      {/* Add Discount Rule Form */}
      <form onSubmit={handleAddDiscount} style={styles.form}>
        <div style={styles.formRow}>
          <TextField
            label='Min Price'
            type='number'
            value={newDiscount.min}
            disabled={noMin}
            onChange={e =>
              setNewDiscount({
                ...newDiscount,
                min: parseFloat(e.target.value),
              })
            }
            fullWidth
          />
          <Checkbox
            checked={noMin}
            onChange={e => {
              setNewDiscount({ ...newDiscount, min: 0 })
              setNoMin(!noMin)
            }}
          />
          <span>No Min</span>
        </div>

        <div style={styles.formRow}>
          <TextField
            label='Max Price'
            type='number'
            value={newDiscount.max}
            disabled={noMax}
            onChange={e =>
              setNewDiscount({
                ...newDiscount,
                max: parseFloat(e.target.value),
              })
            }
            fullWidth
          />
          <Checkbox
            checked={noMax}
            onChange={e => {
              setNewDiscount({ ...newDiscount, max: 9999999 })
              setNoMax(!noMax)
            }}
          />
          <span>No Max</span>
        </div>

        <div style={styles.formRow}>
          <TextField
            label='Discount Percentage'
            type='number'
            value={newDiscount.percentage}
            min={1}
            max={100}
            onChange={e =>
              setNewDiscount({
                ...newDiscount,
                percentage: parseFloat(e.target.value),
              })
            }
            fullWidth
          />
        </div>

        <Button
          type='submit'
          variant='contained'
          fullWidth
          style={{ backgroundColor: '#51a4ac' }}
        >
          Add Discount Rule
        </Button>
      </form>
    </div>
  )
}

const styles = {
  adminSection: {
    maxWidth: '600px',
    margin: 'auto',
    padding: '20px',
    borderRadius: '8px',
    backgroundColor: '#f9f9f9',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
  },
  discountList: {
    listStyleType: 'none',
    padding: 0,
  },
  discountItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: '10px',
    borderRadius: '5px',
    marginBottom: '8px',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
  },
  deleteButton: {
    backgroundColor: '#c53b3a',
    marginLeft: '10px',
  },
  form: {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  formRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
}

export default Discounts
